import css from "./call-button.module.scss";
import {faPhone} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const CallButton = () => {
    return (
        <div className={css.container}>
            <a href="tel:+31224590404" className={css.callButton}>
                <FontAwesomeIcon icon={faPhone} className={css.phoneIcon} />
                <span className={css.text}>Bel ons</span>
            </a>
        </div>
    )
}

export default CallButton